import { render } from "./Withdrawal.vue?vue&type=template&id=31f1444d&ts=true"
import script from "./Withdrawal.vue?vue&type=script&lang=ts"
export * from "./Withdrawal.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__